// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"2e7e0598","513":"f403d710","787":"419723f6","999":"c259da06"}[chunkId] + ".chunk.js";
};